export const getAllowedRangeValues = field => {
	return Array.isArray(field.allowedValues)
		? field.allowedValues
		: [];
};

export const hasAllowedRangeValues = field => {
	return getAllowedRangeValues(field).length > 0;
};

export const getSelectedRangeValue = (value, field) => {
	return value || field.defaultValue;
};

export const getSelectedRangeIndex = (allowedValues, selectedValue) => {
	const selectedIndex = allowedValues.findIndex(item => {
		return String(item) === String(selectedValue);
	});

	return selectedIndex >= 0 ? selectedIndex : 0;
};

export const getCurrentRangeValue = ({
	field,
	value
}) => {
	const allowedValues = getAllowedRangeValues(field);

	if (allowedValues.length > 0) {
		const selectedValue = getSelectedRangeValue(value, field);
		const currentIndex = getSelectedRangeIndex(allowedValues, selectedValue);

		return allowedValues[currentIndex];
	}

	return Number(value || field.defaultValue || field.min || 0);
};

export const getRangeProgress = ({
	field,
	value
}) => {
	const allowedValues = getAllowedRangeValues(field);

	if (allowedValues.length > 0) {
		const selectedValue = getSelectedRangeValue(value, field);
		const currentIndex = getSelectedRangeIndex(allowedValues, selectedValue);

		if (allowedValues.length === 1) {
			return 0;
		}

		return (currentIndex / (allowedValues.length - 1)) * 100;
	}

	const min = Number(field.min || 0);
	const max = Number(field.max || 100);
	const currentValue = Number(value || field.defaultValue || min);

	if (max === min) {
		return 0;
	}

	return ((currentValue - min) / (max - min)) * 100;
};

export const getRangeInputValue = ({
	field,
	value
}) => {
	const allowedValues = getAllowedRangeValues(field);

	if (allowedValues.length > 0) {
		const selectedValue = getSelectedRangeValue(value, field);
		return String(getSelectedRangeIndex(allowedValues, selectedValue));
	}

	return value ?? "";
};

export const getRangeMin = field => {
	return hasAllowedRangeValues(field) ? "0" : field.min;
};

export const getRangeMax = field => {
	const allowedValues = getAllowedRangeValues(field);

	return allowedValues.length > 0
		? String(allowedValues.length - 1)
		: field.max;
};

export const getRangeStep = field => {
	return hasAllowedRangeValues(field) ? "1" : field.step;
};

export const getRangeValueFromInput = ({
	field,
	inputValue
}) => {
	const allowedValues = getAllowedRangeValues(field);

	if (allowedValues.length > 0) {
		const newIndex = Number(inputValue);
		return String(allowedValues[newIndex]);
	}

	return inputValue;
};